import * as React from 'react'
import { IToastProps } from "./IToastProps";
import { IToastState } from "./IToastState";;
import { connect } from 'react-redux'

import * as actions from 'src/actions/toastAction';
import { ToastContainer, toast } from 'react-toastify';

class Toast extends React.Component<IToastProps, IToastState> {

    constructor(props: IToastProps) {
        super(props)
        this.state = {
            show: false
        };
    }

    componentWillReceiveProps(nextProps: Readonly<IToastProps>, nextContext: any): void {

        console.log(this.props.toast , 'tttttttt')

        nextProps.toast.show ?
            (
                toast(nextProps.toast.title)
            ) :
            null

    }

    render() {
        console.log(this.props.toast , 'tttttttt')
        return (

            <div>
                <ToastContainer />
            </div>
        )
    }

}

/* const mapDispatchToProps = (dispatch: any, ownProps: IToastProps) => {
    return {
        show: (cb) => dispatch(actions.toast(cb)),

    }
} */


function mapsStateToProps(state) {
    return {
        toast: state.toast
    };
}

export default connect(mapsStateToProps, null)(Toast);




// WEBPACK FOOTER //
// ./src/components/toastComponent/Toast.tsx